import React, { useCallback, useEffect, useState } from "react";
    import api, { BULAN, fileUrl, formatRupiah, formatTanggal } from "@/lib/api";
    import Layout, { PageTitle } from "@/components/Layout";
    import { NAV_GURU } from "@/lib/nav";
    import { FilterBar } from "@/components/FilterBar";
    import { FileText } from "lucide-react";

    const F_EMPTY = { bulan: "", tahun: "" };
    const TAHUN_OPTS = (() => {
      const y = new Date().getFullYear();
      return [y + 1, y, y - 1, y - 2, y - 3].map((n) => ({ v: String(n), label: String(n) }));
    })();

    export function GajiGuru() {
      const [items, setItems] = useState([]);
      const [filters, setFilters] = useState(F_EMPTY);
      const [applied, setApplied] = useState(F_EMPTY);

      const load = useCallback(async () => {
        try { const { data } = await api.get("/gaji"); setItems(data); }
        catch (e) { console.error(e); }
      }, []);
      useEffect(() => { load(); }, [load]);

      const visible = items.filter((it) => {
        if (applied.bulan && it.bulan !== applied.bulan) return false;
        if (applied.tahun && String(it.tahun) !== String(applied.tahun)) return false;
        return true;
      });

      return (
        <Layout nav={NAV_GURU}>
          <PageTitle title="Daftar Gaji Saya" />
          <FilterBar
            filters={filters} setFilters={setFilters}
            onApply={() => setApplied({ ...filters })}
            onReset={() => { setFilters(F_EMPTY); setApplied(F_EMPTY); }}
            dataTestidPrefix="guru-gaji-filter"
            fields={[
              { key: "bulan", type: "select", label: "Bulan", options: BULAN },
              { key: "tahun", type: "select", label: "Tahun", options: TAHUN_OPTS },
            ]}
          />
          <section className="pp-card pp-freeze overflow-hidden">
            <table className="w-full text-sm" data-testid="guru-gaji-table">
              <thead><tr className="pp-table-header">
                <th className="text-left px-5 py-3">Tahun</th>
                <th className="text-left px-5 py-3">Bulan</th>
                <th className="text-right px-5 py-3">Jumlah Diterima</th>
                <th className="text-left px-5 py-3">Tgl Bayar</th>
                <th className="text-left px-5 py-3">Slip Gaji</th>
              </tr></thead>
              <tbody>
                {visible.length === 0 && (
                  <tr><td colSpan={5} className="text-center py-10 text-slate-400 italic">Belum ada gaji.</td></tr>
                )}
                {visible.map((it) => (
                  <tr key={it.id} className="pp-row">
                    <td className="px-5 py-3">{it.tahun}</td>
                    <td className="px-5 py-3">{BULAN.find((b) => b.v === it.bulan)?.label}</td>
                    <td className="px-5 py-3 text-right font-mono">{formatRupiah(it.jumlah)}</td>
                    <td className="px-5 py-3 text-slate-600">{formatTanggal(it.tanggal_bayar)}</td>
                    <td className="px-5 py-3">
                      {it.slip_url
                        ? <a href={it.slip_url} target="_blank" rel="noreferrer" className="text-indigo-600 text-xs inline-flex items-center gap-1"><FileText className="w-3.5 h-3.5" />Drive</a>
                        : it.slip_file_id
                          ? <a href={fileUrl(it.slip_file_id)} target="_blank" rel="noreferrer" className="text-indigo-600 text-xs inline-flex items-center gap-1"><FileText className="w-3.5 h-3.5" />Lihat</a>
                          : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        </Layout>
      );
    }
    